import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URI}/api`,
});

export const getDashboardSummary = async (employeeId = null, managerId = null) => {
  const response = await API.get("/dashboard/", {
    params: {
      employee_id: employeeId,
      manager_id: managerId
    }
  });
  return response.data;
};

export default API;